import { request } from '@/shared/api/request'
export const notypeFileByUid = (fileGuid) =>
	request({
		url: `/file/s3/notype/${fileGuid}`,
		method: 'GET',
		responseType: 'blob',
	})